import React from "react";

import WComponent from "../common/WComponent";
import PlaybookResultsService from "../../services/PlaybookResultsService";
import RunPlaybookChooserModal from "./RunPlaybookChooserModal";
import StartPlaybookRunModal from "./StartPlaybookRunModal";

class RunPlaybookFlow extends WComponent {
	constructor(props) {
		super(props);
		this.state = {
			runChoice: null,
		};
	}

	onRunChosen = ({ agent, client, clients }) => {
		this.props.onClose();
		this.update({ runChoice: { agent, client, clients } });
	};

	onRunStarted = ({ runId }) => {
		this.update({ runChoice: null });
		this.props.onOpenRun({ runId });
	};

	onConnectSource = ({ action }) => {
		const { history } = this.props;
		const { runChoice } = this.state;
		this.update({ runChoice: null });
		history.push(action.isOnClientPage ? PlaybookResultsService.clientPagePath({ client: runChoice.client }) : action.path);
	};

	render() {
		const { open, playbooks, initialPlaybookId, onClose } = this.props;
		const { runChoice } = this.state;

		return (
			<React.Fragment>
				<RunPlaybookChooserModal
					key={open ? `choosing-${initialPlaybookId || "any"}` : "closed"}
					open={open}
					playbooks={playbooks || []}
					initialPlaybookId={initialPlaybookId}
					onClose={onClose}
					onChosen={this.onRunChosen}
				/>
				{runChoice && (
					<StartPlaybookRunModal
						key={`${runChoice.agent.id}-${runChoice.client ? runChoice.client.id : "connected"}`}
						open
						agent={runChoice.agent}
						clientId={runChoice.client ? runChoice.client.id : null}
						clientName={runChoice.client ? runChoice.client.name : null}
						clients={runChoice.clients}
						onClose={() => this.update({ runChoice: null })}
						onStarted={this.onRunStarted}
						onConnect={this.onConnectSource}
					/>
				)}
			</React.Fragment>
		);
	}
}

export default RunPlaybookFlow;
